export default "/build/images/logo-arabic-300x87.png?78f88d81ef738f00668f008e9f07f606";